module.exports = __webpack_public_path__ + "media/images/icons/consultation-05-6e44f137a2a677cd626ef74ff2099b11.svg";